import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'

function resolveAvatarUrl(avatarUrl, missingImg) {
  if (!avatarUrl || avatarUrl.includes('missing')) {
    return missingImg
  }
  return avatarUrl
}

class SentConnectItem extends React.Component {
  renderTime() {
    const today = moment(new Date())
    const expDate = moment(this.props.req.created_at).add(7, 'days')
    const diffTime = expDate.diff(today, 'hours')
    const days = Math.trunc(diffTime / 24)
    const hours = diffTime - (days * 24)
    return(`${days} day${days !== 1 ? 's' : ''} ${hours} hour${hours !== 1 ? 's' : ''}`)
  }

  render() {
    const { requestee } = this.props.req

    return(
      <article className="connectsRequestCard">
        <div className="connectsRequestCard__top">
          <button
            type="button"
            className="connectsRequestCard__avatar"
            onClick={() => window.location.assign(`/profile/${requestee.slug}`)}
          >
            <img
              src={resolveAvatarUrl(requestee.avatar_url, this.props.missingImg)}
              alt=""
            />
          </button>
          <div className="connectsRequestCard__body">
            <p className="connectsRequestCard__expiry">Expires in {this.renderTime()}</p>
            <p className="connectsRequestCard__message">{this.props.req.msg}</p>
          </div>
        </div>
      </article>
    )
  }
}

SentConnectItem.propTypes = {
  req: PropTypes.object.isRequired,
  missingImg: PropTypes.string.isRequired,
}

export default SentConnectItem
